import { SubscriptionAnalyseModal } from '../../../../styledComponents/Modals/SubscriptionAnalyseModal/SubscriptionAnalyseModal';
import { useAAEditSubscriptionAnalyseModal } from './aaEditSubscriptionAnalyseModal.hooks';

type AASubscriptionAnalyseModalProps = {
  onAnalyseSuccess?: () => void;
};

const AASubscriptionAnalyseModal = ({
  onAnalyseSuccess,
}: AASubscriptionAnalyseModalProps) => {
  const {
    isSubscriptionAnalyseLoading,
    isSubscriptionMembershipInProgress,
    handleSubmit,
    initialValues,
    handleCancel,
    totalMemberships,
  } = useAAEditSubscriptionAnalyseModal(onAnalyseSuccess);
  return (
    <SubscriptionAnalyseModal
      isSubscriptionAnalyseLoading={isSubscriptionAnalyseLoading}
      isSubscriptionMembershipInProgress={isSubscriptionMembershipInProgress}
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      totalMemberships={totalMemberships}
    />
  );
};

export default AASubscriptionAnalyseModal;
